export const timezones = [
    // Antarctica
    'Antarctica/Palmer',

    // North America
    'America/Anchorage',
    'America/Los_Angeles',
    'America/Denver',
    'America/Chicago',
    'America/New_York',

    // South America
    'America/Sao_Paulo',

    // Europe
    'Europe/London',
    'Europe/Paris',
    'Europe/Bucharest',
    'Europe/Moscow',

    // Africa
    'Africa/Lagos',
    'Africa/Nairobi',

    // Asia
    'Asia/Dubai',
    'Asia/Karachi',
    'Asia/Dhaka',
    'Asia/Bangkok',
    'Asia/Shanghai',
    'Asia/Tokyo',

    // Australia/Oceania
    'Australia/Sydney',
    'Pacific/Auckland',
    'Pacific/Tongatapu',
    'Pacific/Guadalcanal',

    // Atlantic and UTC
    'Atlantic/Azores',
    'Etc/UTC',
  ];